var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgShift = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0527 24.1426V32.8586H27.653V24.1426H33.328L23.3533 13.8426L13.3787 24.1426H19.0527ZM22.8326 11.4599C23.1177 11.1657 23.5891 11.1657 23.874 11.4599L36.9324 24.9441C37.3784 25.4046 37.0525 26.1755 36.4117 26.1755H29.6835V34.1654C29.6835 34.5664 29.3588 34.8915 28.9583 34.8915H17.7474C17.3469 34.8915 17.0222 34.5664 17.0222 34.1654V26.1755H10.2949C9.65432 26.1755 9.32837 25.4046 9.77436 24.9441L22.8326 11.4599Z",
    fill: "#333333"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShift, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shift.59b55bc4.svg";
export { ForwardRef as ReactComponent };